export default __webpack_public_path__ + "static/media/editor-2.0a007732.jpg";